import { LogsPage } from '@/components/administracao/LogsPage';

const LogsPageWrapper = () => {
  return <LogsPage />;
};

export default LogsPageWrapper;
